import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.TAGS,
    method: "get",
    params,
  });
}

function create(data) {
  return request({
    url: ENDPOINT.TAGS,
    method: "post",
    data,
  });
}

function update(data) {
  return request({
    url: `${ENDPOINT.TAGS}/${data.id}`,
    method: "patch",
    data,
  });
}

function remove(data) {
  return request({
    url: `${ENDPOINT.TAGS}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  create,
  update,
  remove,
};
